import React from "react";
import SchemaForm from "components/util/schema_form/SchemaForm";
import l from "components/util/l";

const PresentationTemplateForm = ({
  onSubmitForm
}) => {
  return <div className="card">
    <div class="card-body">
      <SchemaForm
        schema={[
          {
            type: "TEXT",
            name: "full_name",
            label: l("Nombre%PA244"),
          },
          {
            type: "TEXT",
            name: "email",
            label: l("Correo electrónico%PA245"),
          },
          {
            type: "TEXT_AREA",
            name: "additional_comments",
            label: l("Mensaje%PA246"),
          }
        ]}
        initialValues={{}}
        submitText={l("Enviar%GA105")}
        onSubmit={(values) => onSubmitForm(values)}
      />
    </div>
  </div>;
}

export default PresentationTemplateForm;